import clsx from "clsx";


export function BasePropertyInput({ children, className, disabled, inputBox = true, error, onClick, title }:
    { children: React.ReactNode, className?: string, disabled?: boolean, inputBox?: boolean, error?: boolean, onClick?: () => void,title?:string }) {

    return <div title={title} className={clsx({ 'input-box': inputBox, disabled, error }, className)} onClick={onClick}  >
        {children}
    </div>
}